$shm_hitalama_map_widget_float_text_md $shm_hitalama_map_widget_float
	link_favicon true
	controls /
		<= Md $shm_hitalama_text
			text <= text \
			favicon <= link_favicon
	contextmenu_body /
		^
		<= Md_download $mol_button_download
			title \Скачать .md
			blob <= md_download_blob null
			file_name <= md_download_file_name \markdown.md
	settings_content /
		<= Link_favicon_row $mol_view
			sub /
				<= Link_favicon $mol_check_box
					title \Иконки сайтов у ссылок
					checked? <=> link_favicon? true
				<= Link_favicon_help $mol_pop_over
					align \top_left
					Anchor <= Link_favicon_help_anchor $mol_button_minor
						hint \Почему иконки могут не появиться
						sub / <= Link_favicon_help_icon $mol_icon_help_circle_outline
					bubble_content /
						<= Link_favicon_help_text $mol_view
							sub / \Если иконки сайтов не появились, то проверьте, не заблокированы ли у вас cookie для favicon.yandex.net
